import Intercom from '@intercom/messenger-js-sdk';
import { User } from 'src/types/common.types';
import { UserType } from '../../consts/userType';

class IntercomFacade {
  private readonly config: typeof IntercomConfig;
  constructor(config: typeof IntercomConfig) {
    this.config = config;
  }

  public initIntercom(user: User, userType: UserType) {
    if (!this.config.enabled) {
      return;
    }

    Intercom({
      app_id: this.config.appId,
      name: user.name,
      email: user.email,
      hide_default_launcher: this.config.hideLauncher,
      action_color: 'white',
      // custom attributes
      // those need to be added manually to intercom
      // see https://www.intercom.com/help/en/articles/179-create-and-track-custom-data-attributes-cdas
      app_name: 'Pilot App',
      pilot_app_user_type: userType,
    });
  }
}

export const intercomSingleton = new IntercomFacade(IntercomConfig);
